import './AppAufa.css';
import { useState, useEffect, useContext, useCallback } from 'react';
import CloseSave from '../../../design/close';
import AppAufaProjects from './AufaProjects/AppAufaProjects';
import Main from './Main';
import AddNames from '../addNames/AppAddNames';
import AppAccount from '../account/AppAccount';
import { AppContext } from '../../../desktop/AppProviderDesktop';
import { updateMain } from './functionAufa';
import Massage from '../../../design/Massage';
import { fetchPostAufa } from '../../../../faetures/fetch';
// import Draggable from 'react-draggable';

export default function AppAufa({ setClose, namesList, num_of_docket, data, updateDataDocketList, updateDataDocketObject, setCloseMain }) {
    // console.log("In App Aufa", "namesList", namesList, "num_of_docket", num_of_docket, "data", data)
    const [projectOpen, setProjectOpen] = useState(false);
    const [projectSelect, setProjectSelect] = useState({ name: '', id: 0 });
    const [namesListAufa, setNamesListAufa] = useState([]);
    const [flight, setFlight] = useState(true);
    const [dataFlightCar, setDataFlightCar] = useState({ fa: [], fr: [], ca: [], cr: [] });
    const [dataMain, setDataMain] = useState({});
    const [dataMainOld, setdataMainOld] = useState({});
    const [price, setPrice] = useState({ fa: 0, fr: 0, ca: 0, cr: 0 });
    const [namesInvoices, setNamesInvoices] = useState({});
    const [dataToAccount, setDataToAccount] = useState({ email: '', phone: '', save: '', invoices: {}, status: 5 });
    const [settingProject, setSettingProject] = useState({});
    const [idAufa, setIdAufa] = useState(0);
    const [agreeToContinue, setAgreeToContinue] = useState(true);
    const [showExitMessage, setShowExitMessage] = useState(false);
    const [message, setMessage] = useState({ display: false, text: '' });
    const [changeMade, setChangeMade] = useState(false);
    const { settingsAufa } = useContext(AppContext);
    const text = "האם אתה בטוח שברצונך לצאת ללא שמירה?"

    const splitPassenger = (passengerId, passengerName) => {
        let data_to_send = {
            names: Object.keys(namesListAufa), numOfDocket: num_of_docket, email: dataToAccount.email, phone: dataToAccount.phone, save: dataToAccount.save, data: data.data,
            invoices: dataToAccount.invoices, status: dataToAccount.status, idAufa: idAufa, splitPassenger: passengerId, splitPassengerName: passengerName
        };
        // console.log("data_to_send in splitPassenger AppAufa", data_to_send);
        fetchPostAufa('split-aufa', data_to_send)
            .then((res) => {
                console.log(res);
                switch (res.status) {
                    case 200:
                        console.log("status 200");
                        setMessage({ display: true, text: 'משתמש פוצל בהצלחה' });
                        break;
                    case 408:
                        console.log("status 200");
                        setMessage({ display: true, text: 'לא ניתן לפצל הזמנה עם נוסע בודד' });
                        break;
                    case 400:
                        throw new Error('Internal Server Error');
                    case 500:
                        throw new Error('Internal Server Error');

                    default:
                        throw new Error('Error');
                        break;
                }


                setTimeout(() => {
                    setClose();
                    setCloseMain();
                }, 3000);
            })
            .catch((err) => {
                console.log(err);
                setMessage({ display: true, text: 'שגיאה בפיצול משתמש' });
            })
    }

    useEffect(() => {
        // start
        if (Object.keys(data).length) {

            let names = {};
            let dataFlights = {};
            let dataPriceOfFlights = {};

            let data_to_account = { email: data['email'], phone: data['phone'], save: data['save'], invoices: data['invoices'], status: data['status'] };

            Object.values(data['names']).map((key) => {
                names[key] = { name: `${namesList[key]['firstName']} ${namesList[key]['lastName']}`, dob: namesList[key]['dob'], credit: namesList[key]['credit'] };
            })

            Object.keys(data['data']).map((value) => {
                let dataFlightSplice = data['data'][value]['data'];
                console.log("dataFlightSplice", dataFlightSplice);
                (typeof data['data'][value]['data'] === 'string') || dataFlightSplice.splice(1, 1);
                dataFlights[value] = (typeof data['data'][value]['data'] === 'string') ? data['data'][value]['data'] : dataFlightSplice;
                dataPriceOfFlights[value] = Number(data['data'][value]['price']);
            })

            setdataMainOld(dataFlights);
            setDataMain(dataFlights);
            setPrice(dataPriceOfFlights);
            setDataToAccount(data_to_account);
            setNamesListAufa(names);
            setIdAufa(data['idDocket']);
            setSettingProject(settingsAufa[data['project']]);
            setProjectSelect({ name: projectSelect.name, id: data['project'] });
        }
    }, [data])

    useEffect(() => {
        projectSelect.id && setSettingProject(settingsAufa[projectSelect.id]);
    }, [projectSelect])

    const insertFlightCarInMain = () => {
        setChangeMade(true);
        setProjectOpen(false);
        setAgreeToContinue(false);

        let [data, price] = updateMain(dataToAccount.status, dataFlightCar, dataMainOld, settingProject);

        setDataMain(data);
        setPrice(price);
    }

    function updateNames(value) {
        setChangeMade(true);
        setNamesListAufa(value);
        setAgreeToContinue(false);
    }

    function closeMessage() {
        setShowExitMessage(false);
    }

    function confirmExit() {
        setShowExitMessage(false);
        setClose();
    }

    function onClickSetClose() {
        if (!changeMade)
            setClose();
        else
            setShowExitMessage(true);
    }

    return (<>
        <div className="aufa-projects-main main-docket centered-draggable">
            {message.display && (
                <Massage
                    text={message.text}
                    animation={true}
                    setClose={() => setMessage({ display: false, text: '' })}
                />
            )}

            {showExitMessage && (
                <div style={{
                    position: 'fixed', top: '50%', left: '50%', width: '400px', padding: '20px', transform: 'translate(-50%, -50%)', zIndex: 1000,
                }}>
                    <Massage
                        text={text.toString().padStart(7, "0")}
                        buttonAgree={confirmExit}
                        setClose={closeMessage}
                        style={{ width: '10px', margin: '0 auto' }}
                    />
                </div>
            )}

            <div className='aufa-projects-head'>
                <CloseSave setClose={onClickSetClose} bc={'rgba(1,1,1,0)'} />
                <CloseSave setClose={() => { }} text={"שמור"} bc={'rgba(1,1,1,0)'} left={false} fs='16pt' />
                <p className='aufa-projects-head-text'> אעופה טורס </p>
            </div>

            <div className='aufa-projects-flight'>
                <div>
                    <p onClick={() => { setFlight(true); setProjectOpen(true) }} > הוסף טיסה</p>
                    <p onClick={() => { setFlight(false); setProjectOpen(true) }} > הוסף נסיעות פנים </p>
                    <p>הוסף שירותים </p>
                </div>

                <Main data={dataMain} price={price} />
            </div>

            <div>
                <div className='aufa-projects-names'>
                    <AddNames
                        names={namesList}
                        namesList={namesListAufa}
                        setNamesList={(value) => updateNames(value)}
                        splitPassenger={splitPassenger}
                    />
                </div>

                <div className='aufa-projects-account'>
                    <AppAccount
                        data={dataMain}
                        dataOld={dataMainOld}
                        projectId={projectSelect.id}
                        names={namesListAufa}
                        setPrice={setPrice}
                        price={price}
                        num_of_docket={num_of_docket}
                        namesInvoices={namesInvoices}
                        setNamesInvoices={setNamesInvoices}
                        dataToAccount={dataToAccount}
                        setDataToAccount={setDataToAccount}
                        updateDataDocketList={updateDataDocketList}
                        updateDataDocketObject={updateDataDocketObject}
                        setClose={setClose}
                        idAufa={idAufa}
                        settingProject={settingProject}
                        setDataMain={setDataMain}
                        agreeToContinue={agreeToContinue}
                        setAgreeToContinue={setAgreeToContinue}
                        setCloseMain={setCloseMain}
                    />
                </div>
            </div>
        </div>
        {projectOpen &&
            <AppAufaProjects
                setClose={() => setProjectOpen(false)}
                flight={flight}
                setFlight={setFlight}
                setProjectSelect={setProjectSelect}
                projectSelect={projectSelect}
                dataFlightCar={dataFlightCar}
                setDataFlightCar={setDataFlightCar}
                insertFlightCar={insertFlightCarInMain}
                setDataMain={setDataMain}
            />
        }


    </>
        // </Draggable>
    );
}
